import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@shared/models/settings/app-settings';
import { map, Observable, of, tap } from 'rxjs';
import { ApiCacheService } from '../cache-service/api-cache.service';
import { RequestState, RequestStatus } from '@shared/models/request-state';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

  constructor(
    private http: HttpClient,
    private cacheService: ApiCacheService
  ) { }

  //private readonly apiUrl = environment.apiUrl;
  private readonly apiUrl = './assets/data/defaultUserSettings.json'


  // FIX ME: This is the original code that to be replaced with PostUserSettings
  getUserSettings(): Observable<AppSettings> {
    const cachedResponse = localStorage.getItem('appSettings');
    const url = `${this.apiUrl}`;

    if (cachedResponse) {
      const response = JSON.parse(cachedResponse);
      return of(response);
    }
    else {
      return this.http.get<AppSettings>(this.apiUrl)
        .pipe(
          tap( (settings) => {
            localStorage.setItem('appSettings', JSON.stringify(settings))
          })
        )
    }
  }

  postUserSettings(updatedSettings?: AppSettings): Observable<RequestState<AppSettings>> {

    /**
     * Intially check to see if there are user settings in cache and if not load the default settings
     * If there are user settings in cache, check if the user settings have changed and post the new settings
     * 
     */


    //check for cached user settings
    const cachedUserSettings = localStorage.getItem('appSettings');
    if (cachedUserSettings) {
      const parsedUserSettings = JSON.parse(cachedUserSettings);

      //console.log('cached settings', parsedUserSettings, 'appSettingsChange', updatedSettings);
      
      // if cached user settings exist and there are changes, post the new settings
      if (updatedSettings != parsedUserSettings) {
        //console.log('posting new settings');
        return this.http.post<AppSettings>(this.apiUrl, updatedSettings).pipe(
         map( (settings) => {
          if (settings) {
            localStorage.setItem('appSettings', JSON.stringify(settings));
          }
            return new RequestState<AppSettings>(
              RequestStatus.IsCompleteWithResponse,
              settings
            );
         }) 
        )
      }
      else {
        //console.log('no changes detected');
        return of(new RequestState<AppSettings>(
          RequestStatus.IsCompleteWithResponse,
          parsedUserSettings
        ));
      }
    }

    // post and load default settings if no cached user settings and post the new settings
    else  {
      //console.log('no cached settings found, loading default settings');
      const defaultSettings: AppSettings = {
        dashboardViewDefault: 0,
        dateTimeFormatDefault: 'local',
        filter: {
          flights: true,
          deadhead: true,
          cancelled: true
        },
        sortOrder: 0
      }
      return this.http.post<AppSettings>(this.apiUrl, defaultSettings).pipe(
        map( (settings) => {
          if (settings) {
            localStorage.setItem('appSettings', JSON.stringify(settings));
          }

          return new RequestState<AppSettings>(
            RequestStatus.IsCompleteWithResponse,
            settings
          );
        })
      );
    }




    // return this.http.post<AppSettings>('.assets/dummyData/dummyUserSettings.json', settings)
    //   .pipe(
    //     tap(settings => settings)
    //   )
  }
}
